// import app pages
import Home from '@/app/pages/Home'
import NewsPost from '@/app/templates/NewsPost'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: 'naujiena/:key',
    name: 'Naujiena',
    component: NewsPost
  }
]

export default routes
